import { RealEstate } from '../../../../@types/real-estate-api-types'
import { EntryMode, InsertionIdentification } from '../../../../@types/types'

export const metaToApp = (realEstate: RealEstate, entryMode?: EntryMode): InsertionIdentification => ({
  id: realEstate.id,
  realEstateId: realEstate.realEstateId,
  unitId: realEstate.unitId,
  buildingId: realEstate.buildingId,
  progressState: realEstate.state,
  mapImages: realEstate.mapImages,
  metaInformation: {
    selectedMenuItem: realEstate.metaInformation?.selectedMenuItem,
    entryMode: entryMode ?? realEstate.metaInformation?.entryMode,
  },
})
